import React from 'react'
import { Select } from '@mui/material'
import styled from '@emotion/styled'
import { Field } from 'formik'

import TextField from './FormComponents/TextField'
import MenuItem from './MenuItem'

const SelectField = styled(TextField)`
  & .MuiSelect-select {
    height: 22px;
    border-radius: 4px;
  }
`

export default ({ id, name, label, options, disabled = false, className }) => {
  const generateSelectOptions = () => {
    return (
      options &&
      options.map(option => {
        return (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        )
      })
    )
  }

  return (
    <Field
      as={Select}
      id={id}
      name={name}
      input={<SelectField label={label} className={className} />}
      disabled={options ? disabled : true}
      children={generateSelectOptions()}
    />
  )
}
